// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/right-of-way.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/right-of-way/right-of-way.js';

mount([g0]);
